export const BASE_URL = "https://answer-repo.com/api"